// Jump to top of app (for use on page switch)
const jumpToTop = () => {
  const app = document.querySelector('.App');

  if (app) {
    // debugLog('scrolling to: ', appTop);
    window.scrollTo(0, (app as HTMLElement).offsetTop);
  }
}

export default jumpToTop;
